import React, {
    FC, useEffect, useMemo, useState,
} from 'react';
import classNames from 'classnames';
import { MobilePeriodSelectContainer } from 'app/components/Select';
import { selectedPeriodVar } from 'app/apollo/reaction';
import { delay } from 'app/utils/common';
import { isDate } from 'lodash';
import { isDateInRange } from 'app/utils/date';
import css from './BR1258sets5dishes.module.scss';
import { BR1258Sets5DishesCard } from './BR1258Sets5DishesCard';

import { TCardKey } from '../../sets.record';
import { sliderCardContentMapV2, additionalCardsMap } from './V2CardsContent.record';
import { BR1258Sets5DishesCardStub } from './BR1258Sets5DishesCardStub';

interface IBestSetsMobileSliderV2 {
    isMenuEmpty: boolean
    cardsChain: TCardKey[]
    additionalCardsChain: TCardKey[]
    handleClickToSliderCard: (I: MouseEvent, II: TCardKey) => void
}

const ANIMATION_DURATION = 700;

const BR1258BestSetsMobileSliderV2: FC<IBestSetsMobileSliderV2> = ({
    isMenuEmpty,
    cardsChain,
    additionalCardsChain,
    handleClickToSliderCard,
}: IBestSetsMobileSliderV2) => {
    const [isDateSelectOpen, setIsDateSelectOpen] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [hasNoDishes, setHasNoDishes] = useState<boolean[]>([]);

    const listClasses = useMemo(
        () => classNames({
            [css.gridListNewUI]: isMenuEmpty,
            [css.sliderListNewUI]: !isMenuEmpty,
            [css.listContainerForMoreThreeSetsNewUI]: true,
        }),
        [isMenuEmpty],
    );

    const uddCardClasses = classNames({
        [css.stubContainerNewUI]: !isMenuEmpty,
    });

    return (
        <>
            <div
                className={css.rootNewUI}
                aria-label="ABSets5DishesRoot"
                data-scroll_name="Sets"
            >
                <div className={css.sliderContainerNewUI}>
                    <div className={listClasses}>
                        {cardsChain.map((cardKey) => {
                            const card = sliderCardContentMapV2.get(cardKey);

                            return (
                                <BR1258Sets5DishesCard
                                    mode="default"
                                    key={cardKey}
                                    cardKey={cardKey}
                                    // @ts-ignore
                                    onClick={(e: MouseEvent) => {
                                        setIsButtonDisabled(true);
                                        delay(ANIMATION_DURATION).then(() => {
                                            setIsButtonDisabled(false);
                                        });
                                        handleClickToSliderCard(e, cardKey);
                                    }}
                                    setHasNoDishes={setHasNoDishes}
                                    disabled={isButtonDisabled}
                                    {...card}
                                />
                            );
                        })}
                        {additionalCardsChain.map((cardKey) => {
                            const card = additionalCardsMap.get(cardKey);
                            const currentPeriod = selectedPeriodVar();
                            const cardVisiblePeriods = card?.period;
                            const isCardVisible = cardVisiblePeriods?.some((period) => isDateInRange(period, currentPeriod));

                            if (!isCardVisible) {
                                return null;
                            }

                            return (
                                <BR1258Sets5DishesCard
                                    mode="default"
                                    key={cardKey}
                                    cardKey={cardKey}
                                    // @ts-ignore
                                    onClick={(e: MouseEvent) => {
                                        setIsButtonDisabled(true);
                                        delay(ANIMATION_DURATION).then(() => {
                                            setIsButtonDisabled(false);
                                        });
                                        handleClickToSliderCard(e, cardKey);
                                    }}
                                    setHasNoDishes={setHasNoDishes}
                                    disabled={isButtonDisabled}
                                    isAdditionalSet
                                    {...card}
                                />
                            );
                        })}
                        <div className={uddCardClasses}>
                            {hasNoDishes.some((value) => Boolean(!value)) && (
                                <BR1258Sets5DishesCardStub
                                    isDynamicPrice={false}
                                    setType=""
                                    disabled={isButtonDisabled}
                                    onClick={() => {
                                        setIsButtonDisabled(true);
                                        delay(ANIMATION_DURATION).then(() => {
                                            setIsButtonDisabled(false);
                                        });
                                        setIsDateSelectOpen(true);
                                    }}
                                />
                            )}
                            {/* Костыль для safari, т.к. этот браузер по-другому работает с правым отступом при overflow scroll */}
                            {!isMenuEmpty && <div className={css.safariStub} />}
                        </div>
                    </div>
                </div>
            </div>
            <MobilePeriodSelectContainer
                isSelectOpened={isDateSelectOpen}
                onClickPeriod={(nextSelectedPeriod: string) => {
                    selectedPeriodVar(nextSelectedPeriod);
                }}
                onClickClose={() => {
                    setIsDateSelectOpen(false);
                }}
            />
        </>
    );
};

export default React.memo(BR1258BestSetsMobileSliderV2);
